<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
          cols="12"
          md="8"
          lg="6"
          xl="4"
          class="text-center">
        <v-card class="elevation-12" max-width="400">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-toolbar-title>
              {{ $t('Сброс пароля') }}
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <v-alert
                class="text-center"
                :value="success"
                type="success">
              {{ $t('В случае наличия регистрации в системе указанному пользователю будет отправлено письмо для подтверждения сброса пароля. Для завершения необходимо пройти по ссылке из письма.') }}
            </v-alert>
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="passwordform" @keydown.native.enter="focusOnBtn('resetPasswordBtn')">
              <validatable-text-input
                  v-model="resetModel.userName"
                  rules="required|max:60"
                  :label="$t('Логин')"
                  prepend-icon="person" />
              <validatable-recaptcha
                  v-if="captchaMethod === CAPTCHA_METHODS.GOOGLE"
                  ref="recaptcha"
                  v-model="resetModel.captcha" />
              <validatable-captcha-gen
                  v-if="captchaMethod === CAPTCHA_METHODS.CAPTCHA_GEN"
                  ref="captchagen"
                  :captcha="resetModel.captcha"
                  @input="inputCaptchaGen" />
            </ValidationObserver>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
                id="cancelBtn"
                v-test="{ btn: 'cancel' }"
                color="primary"
                :to="`${urlRootPath}/`">
              {{ $t('Отмена') }}
            </v-btn>
            <v-btn
                id="resetPasswordBtn"
                ref="resetPasswordBtn"
                v-test="{ btn: 'resetPassword' }"
                color="primary"
                :disabled="isLoading"
                @click="resetPassword">
              {{ $t('Сбросить пароль') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import ValidatableTextInput from '@/components/reused/ui/ValidatableTextInput.vue'
  import ValidatableRecaptcha from '@/components/reused/ui/ValidatableRecaptcha.vue'
  import ValidatableCaptchaGen from '@/components/reused/ui/ValidatableCaptchaGen.vue'
  import { CAPTCHA_METHODS } from '@/constants/business'
  import { mapActions, mapState } from 'vuex'
  import { ACCOUNT, CAPTCHA } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableTextInput,
      ValidatableRecaptcha,
      ValidatableCaptchaGen
    },
    data () {
      return {
        CAPTCHA_METHODS,
        isLoading: false,
        success: false,
        resetModel: {
          userName: null,
          captchaId: null,
          captcha: null
        }
      }
    },
    computed: {
      ...mapState(CAPTCHA.NAMESPACE, {
        captchaMethod: state => (state[CAPTCHA.STATE.METHOD] || ''),
        captchaId: state => (state[CAPTCHA.STATE.CAPTCHA_ID] || '')
      })
    },
    created () {
      this.getCaptchaMethod()
    },
    methods: {
      ...mapActions(ACCOUNT.NAMESPACE, {
        resetPasswordAction: ACCOUNT.ACTIONS.RESET_PASSWORD
      }),
      ...mapActions(CAPTCHA.NAMESPACE, {
        getCaptchaMethodAction: CAPTCHA.ACTIONS.GET_CAPTCHA_METHOD
      }),
      resetPassword: async function () {
        await this.hideErrorAction()
        const result = await this.$refs.passwordform.validate()
        if (!result) {
          return
        }

        this.isLoading = true

        try {
          await this.resetPasswordAction(this.resetModel)
          this.success = true
        } catch (error) {
          this.success = false
          if (this.captchaMethod === CAPTCHA_METHODS.GOOGLE) {
            this.$refs.recaptcha.resetCaptcha()
          }
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
          if (this.captchaMethod === CAPTCHA_METHODS.CAPTCHA_GEN) {
            this.$refs.captchagen.reloadImage()
          }
        }
      },
      getCaptchaMethod: async function () {
        this.isLoading = true
        try {
          await this.getCaptchaMethodAction()
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      },
      inputCaptchaGen: function (value) {
        this.resetModel.captcha = value
        this.resetModel.captchaId = this.captchaId
      }
    }
  }
</script>
